import { Component, HostListener } from '@angular/core';
import { PostService } from 'src/app/services/repositories/post.service';
import { Subscription } from 'rxjs';
import { GroupService } from 'src/app/services/repositories/group.service';
import { IResponse } from 'src/app/interfaces/IResponse';
import { SocialMediaService } from 'src/app/services/repositories/social-media.service';
import { UiStateService } from 'src/app/services/utilities/ui-state.service';
import { environment } from 'src/environments/environment';


@Component({
  selector: 'app-linkedin-stats',
  templateUrl: './linkedin-stats.component.html',
  styleUrls: ['./linkedin-stats.component.scss']
})
export class LinkedinStatsComponent {
  data: Array<{
    label: string;
    value: string;
    icon:string,
    unit:string,
    tooltip:string,
    tooltipPosition:string
  }> = [];
  private subscriptions : Subscription[]=[];
  socialMedias: any[] = [];
  isInsightsLoading:boolean=true

  constructor(protected postService: PostService,
  private groupService: GroupService,
  private socialMediaService:SocialMediaService,
  private uiStateService:UiStateService
  ){}
  generalInsightsLabels:string[]=[
    'insights.linkedin.numberOfPublications',
    'insights.linkedin.subscribers',
    'insights.linkedin.likeCount',
    'insights.linkedin.shareCount',
    'insights.linkedin.commentCount',
  ]

  visibilityInsightsLabels:string[]=[
    'insights.linkedin.pageViews',
    'insights.linkedin.newSubscribers',
    // 'insights.linkedin.searchResults',
    'insights.linkedin.impressionCount',
  ]

  indicatorsInsightsLabels:string[]=[
    'insights.linkedin.pageVisits',
    'insights.linkedin.totalEngagement',
    'insights.linkedin.clickCount',
    'insights.linkedin.engagementRate',
  ]

  videoInsightsLabels:string[]=[
    'insights.linkedin.videoViews',
    'insights.linkedin.videoDuration',
  ]

  adsInsightsLabels:string[]=[
    'insights.linkedin.customButtonClicks',
    'insights.linkedin.visitDuration',
  ]

  GetGeneralData(){
    return this.data.filter((item:any)=>this.generalInsightsLabels.includes(item.label))
  }

  GetVisibilityData(){
    return this.data.filter((item:any)=>this.visibilityInsightsLabels.includes(item.label))
  }

  GetIndicatorsData(){
    return this.data.filter((item:any)=>this.indicatorsInsightsLabels.includes(item.label))
  }

  GetVideoData(){
    return this.data.filter((item:any)=>this.videoInsightsLabels.includes(item.label))
  } 

  GetAdsData(){
    return this.data.filter((item:any)=>this.adsInsightsLabels.includes(item.label))
  }
  period={startDate:undefined,endDate:undefined}
  linkedinPageIds:any[]=[]
  linkedinPageNames:any[]=[]
  uiDateRange={}
  setUpDateRange(){
    this.uiStateService.pageStatsdateRangeUpdate$.subscribe((data:any)=>{
      this.uiDateRange=data
    })
    let lsData = localStorage.getItem(environment.sessionData);
     if(lsData){
    const parsedData = JSON.parse(lsData);
    if(parsedData?.filterData?.dateRange ){
      this.period = parsedData.filterData.pageStatsdateRange
    }
   }
     console.log(`[${this.constructor.name}] - initialPeriod ${JSON.stringify(this.period)},${JSON.stringify(this.uiDateRange)}`)
  }
    AllGrouPages:any
  ngOnInit(){ 

    this.setUpDateRange()
    this.data = [
      {"label": "insights.linkedin.numberOfPublications", "value":'--',"icon":"grid","unit":"","tooltip":"tooltip.linkedin.numberOfPublications","tooltipPosition":"tooltip-top"},
      {"label": "insights.linkedin.pageViews", "value":'--',"icon":"eye","unit":"","tooltip":"tooltip.linkedin.pageViews","tooltipPosition":"tooltip-top"},
      {"label": "insights.linkedin.subscribers", "value":'--',"icon":"user","unit":"","tooltip":"tooltip.linkedin.subscribers","tooltipPosition":"tooltip-top"},
      {"label": "insights.linkedin.newSubscribers", "value":'--',"icon":"user-plus","unit":"","tooltip":"tooltip.linkedin.newSubscribers","tooltipPosition":"tooltip-top"},
      {"label": "insights.linkedin.searchResults", "value":'--',"icon":"search","unit":"","tooltip":"tooltip.linkedin.searchResults","tooltipPosition":"tooltip-top"},
      {"label": "insights.linkedin.impressionCount", "value":'--',"icon":"image-view","unit":"","tooltip":"tooltip.linkedin.impressionCount","tooltipPosition":"tooltip-top"},
      {"label": "insights.linkedin.likeCount", "value":'--',"icon":"like","unit":"","tooltip":"tooltip.linkedin.likeCount","tooltipPosition":"tooltip-top"},
      {"label": "insights.linkedin.commentCount", "value":'--',"icon":"chat","unit":"","tooltip":"tooltip.linkedin.commentCount","tooltipPosition":"tooltip-top"},
      {"label": "insights.linkedin.shareCount", "value":'--',"icon":"share","unit":"","tooltip":"tooltip.linkedin.shareCount","tooltipPosition":"tooltip-top"},
      {"label": "insights.linkedin.pageVisits", "value":'--',"icon":"user-visible","unit":"","tooltip":"tooltip.linkedin.pageVisits","tooltipPosition":"tooltip-right"},
      {"label": "insights.linkedin.totalEngagement", "value":'--',"icon":"user-star","unit":"","tooltip":"tooltip.linkedin.totalEngagement","tooltipPosition":"tooltip-top"},
      {"label": "insights.linkedin.clickCount", "value":'--',"icon":"clicks","unit":"","tooltip":"tooltip.linkedin.clickCount","tooltipPosition":"tooltip-top"},
      {"label": "insights.linkedin.engagementRate", "value":'--',"icon":"click","unit":"%","tooltip":"tooltip.linkedin.engagementRate","tooltipPosition":"tooltip-top"},
      {"label": "insights.linkedin.clickRate", "value":'--',"icon":"grid","unit":"","tooltip":"tooltip.linkedin.clickRate","tooltipPosition":"tooltip-top"},
      {"label": "insights.linkedin.videoViews", "value":'--',"icon":"video-film","unit":"","tooltip":"tooltip.linkedin.videoViews","tooltipPosition":"tooltip-top"},
      {"label": "insights.linkedin.videoDuration", "value":'--',"icon":"timer-play","unit":"min","tooltip":"tooltip.linkedin.videoDuration","tooltipPosition":"tooltip-top"},
      {"label": "insights.linkedin.customButtonClicks", "value":'--',"icon":"button-click","unit":"","tooltip":"tooltip.linkedin.customButtonClicks","tooltipPosition":"tooltip-top"},
      {"label": "insights.linkedin.visitDuration", "value":'--',"icon":"timer-eye","unit":"sec","tooltip":"tooltip.linkedin.visitDuration","tooltipPosition":"tooltip-top"},
    ];
    this.subscriptions.push(
      this.postService.currentGroups.subscribe((g: number[]) => {
        if (g.length == 0)
          g = this.postService.getGroupScopesFromLocalStorage();
        
        if (g.length > 0) {
          this.groupService.getGroupByIds(g).subscribe((res: IResponse) => {
            this.isInsightsLoading=true
            this.AllGrouPages =this.getRecursiveSocialMediaPages(res.data)
            this.linkedinPageIds = this.AllGrouPages.filter((sm:any)=>sm.source=="linkedin").map((lp:any)=>lp.id)||[];
            this.linkedinPageNames =this.AllGrouPages.filter((sm:any)=>sm.source=="linkedin").map((lp:any)=> {return {id:lp.id,name:lp.name,url:lp.url}})||[];
            // console.log("AllGrouPages",this.AllGrouPages,"linkedinPageIds",this.linkedinPageIds,"period",this.period,"res",res.data)
            if(this.linkedinPageIds.length>0){
              this.subscriptions.push(
                this.socialMediaService.getPageStatesProgress(this.linkedinPageIds,this.period).subscribe((res:any)=>{
                  
                    const resObj = res.data.results?.reduce((sums:any, obj:any) => {
                      for (const key in obj) {
                        sums[key] = (sums[key] || 0) + (obj[key] || 0);
                      }
                      return sums;
                    }, {});
                    for(let item of this.data){
                      for(let key in item){
                        if(key ==="label"){
                          const prop = item[key].replace("insights.linkedin.","")
                          item.value = prop=="searchResults"?"--" :resObj[prop]
                        }
                      }
                    }
                  })
                )
              this.isInsightsLoading=false
            }
            else{
              console.log("no linkedin pages")
              this.isInsightsLoading=false
            }
          });
        }
      })
    );
  }

  updateStats(dateValue:any){
     console.log("[linkedin] dateRange Update dateValue",dateValue,"period",this.period)
    if(dateValue.pageStatsendDate>new Date() ){
      dateValue.pageStatsendDate = new Date()
    }
    
    //update the date range in the service
    this.uiStateService.pageStatsupdateDateRange(dateValue);
    this.period = dateValue

    this.isInsightsLoading=true
    if(this.AllGrouPages && this.AllGrouPages.length>0){
      this.linkedinPageIds = this.AllGrouPages.filter((sm:any)=>sm.source=="linkedin").map((lp:any)=>lp.id)||[];
      this.linkedinPageNames =this.AllGrouPages.filter((sm:any)=>sm.source=="linkedin").map((lp:any)=> {return {id:lp.id,name:lp.name,url:lp.url}})||[];
      // console.log("AllGrouPages",this.AllGrouPages,"linkedinPageIds",this.linkedinPageIds,"period",this.period)
      if(this.period && this.linkedinPageIds.length>0){
        this.socialMediaService.getPageStatesProgress(this.linkedinPageIds,this.period).subscribe((res:any)=>{
          console.log(res.data)
          this.period=res.data.period
          const resObj = res.data.results?.reduce((sums:any, obj:any) => {
            for (const key in obj) {
              if(key!="searchResults"){
                sums[key] = (sums[key] || 0) + (obj[key] || 0);
              }
              else{
                sums[key] = "--"
              }
            }
            return sums;
          }, {});
          for(let item of this.data){
            for(let key in item){
              if(key ==="label"){
                const prop = item[key].replace("insights.linkedin.","")
                item.value = resObj[prop]
              }
            }
          }
          this.isInsightsLoading=false
        })
        // console.log("end of update States",dateValue,this.period)
      }
    }
  }
  getRecursiveSocialMediaPages(groups: any[]): any[] {
    groups = !Array.isArray(groups) ? [groups] : groups;
    let socialMediaPages: any[] = [];
    groups.forEach((group: any) => {
      // Add the group's social media pages if any
      if (group.socialMedia && group.socialMedia.length > 0) {
        socialMediaPages = [...socialMediaPages, ...group.socialMedia];
      }

      // Recursively add social media pages from children
      if (group.children && group.children.length > 0) {
        for (let child of group.children) {
          socialMediaPages = [
            ...socialMediaPages,
            ...this.getRecursiveSocialMediaPages(child),
          ];
        }
      }
    });
    //removing any duplicates
    const pagesArrayString: string[] = socialMediaPages.map((sm: any) =>
      JSON.stringify(sm)
    );
    const uniquePagesArrayString = [...new Set(pagesArrayString)];
    this.socialMedias = uniquePagesArrayString.map((sm: any) =>
      JSON.parse(sm)
    );
    return uniquePagesArrayString.map((sm: any) => JSON.parse(sm));
  }

  gVal(data: any){
    return data && Number(data)? Number(data): 0
  }
  // delete this part 
  isPlanned: boolean = true; 
  isPost: boolean = true; 
  isDraft: boolean = true; 
  windowWidth: number = window.innerWidth;
  isLargeView: boolean = false;
  isMediumView: boolean = false;
  isSmallView: boolean = false;
  isVerySmallView: boolean = false;

  @HostListener('window:resize', ['$event'])
  onResize() {
    this.windowWidth = window.innerWidth;

    if (1232 < this.windowWidth && this.windowWidth < 1375) {
      // Medium view
      this.isLargeView = false;
      this.isMediumView = true;
      this.isSmallView = false;
      this.isVerySmallView = false;
    } else if (1375 <= this.windowWidth && this.windowWidth < 1515) {
      // Large view
      this.isLargeView = true;
      this.isMediumView = false;
      this.isSmallView = false;
      this.isVerySmallView = false;
    } else if (this.windowWidth >= 1515) {
      // Extra large view
      this.isLargeView = false;
      this.isMediumView = false;
      this.isSmallView = false;
      this.isVerySmallView = false;
    } else if (this.windowWidth >= 1100 && this.windowWidth < 1232) {
      // Small view (windowWidth <= 1232)
      this.isLargeView = false;
      this.isMediumView = false;
      this.isSmallView = true;
      this.isVerySmallView = false;
    } else {
      this.isLargeView = false;
      this.isMediumView = false;
      this.isSmallView = false;
      this.isVerySmallView = true;
    }
  }

  togglePost() {
    this.isPost = !this.isPost;
  }
  togglePlanned() {
    this.isPlanned = !this.isPlanned;
  }
  // end delete
  ngOnDestroy() {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }
}